<template>
  <form class="register-form">
    <v-text-field
      v-model="state.email"
      label="Email"
      required
      type="email"
      variant="outlined"
      prepend-inner-icon="mdi-email"
      density="comfortable"
      class="mb-4"
    ></v-text-field>

    <v-btn
      block
      size="large"
      color="primary"
      variant="elevated"
      @click="onClickReset"
      :loading="state.loading"
      class="mb-4"
    >
      Send Reset Code
    </v-btn>

    <v-divider class="my-4"></v-divider>

    <div class="text-center">
      <RouterLink :to="URLs.PAGE_AUTH_LOGIN" class="text-decoration-none text-primary">
        Back to Login
      </RouterLink>
    </div>
  </form>
</template>

<script setup lang="ts">
import { URLs } from "@/constants";
import { useAuthStore } from "@/stores/auth";
import { makeAlert } from "@/utils";
import { ref } from "vue";
import { useRouter } from "vue-router";

const authStore = useAuthStore();
const router = useRouter();

const state = ref({
  email: "",
  loading: false
});

const onClickReset = async () => {
  state.value.loading = true;
  const response = await authStore.passwordReset({
    email: state.value.email
  });
  state.value.loading = false;

  if (response.status) {
    makeAlert("Password reset success", "success");
    router.push({
      path: URLs.PAGE_AUTH_CONFIRM_PASSWORD_RESET,
      query: {
        email: state.value.email
      }
    });
  } else {
    makeAlert(response.message, "error");
  }
};
</script>
